<template>
  <base-section id="structure-organization" space="56">
    <v-container fluid>
      <v-row justify="space-between">
        <v-col cols="12" md="10" class="mx-auto">
          <base-business-info
            title="Struktur Organisasi"
          >
          </base-business-info>

          <div class="structure-shell">
            <v-tabs
              v-model="activeTab"
              class="structure-tabs"
              background-color="transparent"
              show-arrows
            >
              <v-tab v-for="tab in tabs" :key="tab" class="text-capitalize">
                {{ tab }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab" class="structure-panels">
              <v-tab-item>
                <div class="structure-visual">
                  <v-img
                    :src="structureImage"
                    class="structure-visual__media"
                    height="460"
                    cover
                  ></v-img>
                </div>
              </v-tab-item>

              <v-tab-item>
                <v-container class="py-8 commissioner-section">
                  <div class="option-bar mb-6">
                    <div class="option-bar__chips chip-scroll">
                      <v-slide-group
                        v-model="selectedBoard"
                        class="board-chip-slide"
                        show-arrows
                        center-active
                        mandatory
                      >
                        <v-slide-item
                          v-for="option in boardOptions"
                          :key="option.key"
                          :value="option.key"
                        >
                          <span
                            :class="['board-chip', { 'board-chip--active': selectedBoard === option.key }]"
                            role="button"
                            tabindex="0"
                            @click="selectBoard(option.key)"
                            @keydown.enter.prevent="selectBoard(option.key)"
                            @keydown.space.prevent="selectBoard(option.key)"
                            :aria-pressed="selectedBoard === option.key"
                          >
                            {{ option.label }}
                          </span>
                        </v-slide-item>
                      </v-slide-group>
                    </div>

                    <div v-if="activeCards.length > 1" class="option-bar__arrows">
                      <v-btn icon color="primary" class="mr-2" @click="prevCard">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="nextCard">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div
                    ref="commissionerStrip"
                    class="d-flex justify-center align-center commissioner-strip mb-10"
                    :class="{
                      'commissioner-strip--grid': useGrid(visibleCards.length, selectedBoard),
                      'commissioner-strip--single': visibleCards.length === 1
                    }"
                  >
                    <div
                      v-for="item in visibleCards"
                      :key="item.key"
                      :class="[
                        'commissioner-thumb-wrapper',
                        'mx-3',
                        {
                          'commissioner-thumb-wrapper--active': item.role === 'current',
                          'commissioner-thumb-wrapper--inactive': item.role !== 'current'
                        },
                        `commissioner-thumb-wrapper--${item.role}`
                      ]"
                    >
                      <v-img
                        :src="require(`@/assets/${item.card.src}`)"
                        :height="imageHeight(item.role, visibleCards.length, selectedBoard)"
                        :width="imageWidth(item.role, visibleCards.length, selectedBoard)"
                        class="commissioner-thumb"
                        :class="[
                          item.role === 'current'
                            ? 'commissioner-thumb--active'
                            : 'commissioner-thumb--inactive',
                          imageSlideClass(item.role)
                        ]"
                        :alt="item.card.name"
                        @click="goTo(item.index)"
                      />
                    </div>
                  </div>

                  <div class="text-center mb-4" v-if="currentCard">
                    <div class="text-h5 font-weight-bold mb-1">
                      {{ currentCard.name.toUpperCase() }}
                    </div>
                    <div class="subtitle-1 primary--text">
                      {{ currentCard.title }}
                    </div>
                  </div>

                  <div
                    class="px-10 py-5 text-center"
                    v-if="currentCard"
                    v-html="currentCard.detail"
                  ></div>

                </v-container>
              </v-tab-item>
                  <!-- <div
                    v-for="group in managementGroups"
                    :key="group.slug"
                    class="management-card"
                  >
                    <p class="eyebrow">{{ group.tag }}</p>
                    <h3>{{ group.title }}</h3>
                    <ul>
                      <li v-for="person in group.members" :key="person.name">
                        <span class="name">{{ person.name }}</span>
                        <span class="role">{{ person.role }}</span>
                      </li>
                    </ul>
                  </div> -->

              <v-tab-item>
                <v-container class="py-8 executive-section audit-section">
                  <div class="option-bar mb-6">
                    <div class="option-bar__chips chip-scroll">
                      <v-slide-group
                        v-model="execSelected"
                        class="board-chip-slide"
                        show-arrows
                        center-active
                        mandatory
                      >
                        <v-slide-item
                          v-for="option in execBoardOptions"
                          :key="option.key"
                          :value="option.key"
                        >
                          <span
                            :class="['board-chip', { 'board-chip--active': execSelected === option.key }]"
                            role="button"
                            tabindex="0"
                            @click="selectExecBoard(option.key)"
                            @keydown.enter.prevent="selectExecBoard(option.key)"
                            @keydown.space.prevent="selectExecBoard(option.key)"
                            :aria-pressed="execSelected === option.key"
                          >
                            {{ option.label }}
                          </span>
                        </v-slide-item>
                      </v-slide-group>
                    </div>

                    <div v-if="execActiveCards.length > 1" class="option-bar__arrows">
                      <v-btn icon color="primary" class="mr-2" @click="prevExec">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="nextExec">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <!-- STRIP FOTO: PREV - CURRENT - NEXT -->
                  <div
                    ref="execStrip"
                    class="d-flex justify-center align-center commissioner-strip mb-10"
                    :class="{
                      'commissioner-strip--grid': useGrid(execVisibleCards.length, 'exec'),
                      'commissioner-strip--single': execVisibleCards.length === 1
                    }"
                  >
                    <div
                      v-for="item in execVisibleCards"
                      :key="item.key"
                      :class="[
                        'commissioner-thumb-wrapper',
                        'mx-3',
                        {
                          'commissioner-thumb-wrapper--active': item.role === 'current',
                          'commissioner-thumb-wrapper--inactive': item.role !== 'current'
                        },
                        `commissioner-thumb-wrapper--${item.role}`
                      ]"
                    >
                      <v-img
                        :src="require(`@/assets/${item.card.src}`)"
                        :height="imageHeight(item.role, execVisibleCards.length, 'exec')"
                        :width="imageWidth(item.role, execVisibleCards.length, 'exec')"
                        class="commissioner-thumb"
                        :class="[
                          item.role === 'current'
                            ? 'commissioner-thumb--active'
                            : 'commissioner-thumb--inactive',
                          execImageSlideClass(item.role)
                        ]"
                        :alt="item.card.name"
                        @click="goToExec(item.index)"
                      />
                    </div>
                  </div>

                  <!-- NAMA & JABATAN -->
                  <div class="text-center mb-4" v-if="execCurrentCard">
                    <div class="text-h5 font-weight-bold mb-1">
                      {{ execCurrentCard.name.toUpperCase() }}
                    </div>
                    <div class="subtitle-1 primary--text">
                      {{ execCurrentCard.title }}
                    </div>
                  </div>

                  <!-- DETAIL -->
                  <div
                    class="px-10 py-5 text-center"
                    v-if="execCurrentCard"
                    v-html="execCurrentCard.detail"
                  ></div>

                </v-container>
              </v-tab-item>

              <v-tab-item>
                <v-container class="py-8 executive-section director-section">
                  <div class="d-flex justify-end align-center flex-wrap mb-6">
                    <div v-if="internalActiveCards.length > 1">
                      <v-btn icon color="primary" class="mr-2" @click="prevInternal">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="nextInternal">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div
                    ref="internalStrip"
                    class="d-flex justify-center align-center commissioner-strip mb-10"
                    :class="{
                      'commissioner-strip--grid': useGrid(internalVisibleCards.length, 'internal'),
                      'commissioner-strip--single': internalVisibleCards.length === 1
                    }"
                  >
                    <div
                      v-for="item in internalVisibleCards"
                      :key="item.key"
                      :class="[
                        'commissioner-thumb-wrapper',
                        'mx-3',
                        {
                          'commissioner-thumb-wrapper--active': item.role === 'current',
                          'commissioner-thumb-wrapper--inactive': item.role !== 'current'
                        },
                        `commissioner-thumb-wrapper--${item.role}`
                      ]"
                    >
                      <v-img
                        :src="require(`@/assets/${item.card.src}`)"
                        :height="imageHeight(item.role, internalVisibleCards.length, 'internal')"
                        :width="imageWidth(item.role, internalVisibleCards.length, 'internal')"
                        class="commissioner-thumb"
                        :class="[
                          item.role === 'current'
                            ? 'commissioner-thumb--active'
                            : 'commissioner-thumb--inactive',
                          execImageSlideClass(item.role)
                        ]"
                        :alt="item.card.name"
                        @click="goToInternal(item.index)"
                      />
                    </div>
                  </div>

                  <div class="text-center mb-4" v-if="internalCurrentCard">
                    <div class="text-h5 font-weight-bold mb-1">
                      {{ internalCurrentCard.name.toUpperCase() }}
                    </div>
                    <div class="subtitle-1 primary--text">
                      {{ internalCurrentCard.title }}
                    </div>
                  </div>

                  <div
                    class="px-10 py-5 text-center"
                    v-if="internalCurrentCard"
                    v-html="internalCurrentCard.detail"
                  ></div>

                </v-container>
              </v-tab-item>

              <v-tab-item>
                <v-container class="py-8 executive-section">
                  <div class="option-bar mb-6">
                    <div class="option-bar__chips chip-scroll">
                      <v-slide-group
                        v-model="commSelected"
                        class="board-chip-slide"
                        show-arrows
                        center-active
                        mandatory
                      >
                        <v-slide-item
                          v-for="option in commsOptions"
                          :key="option.key"
                          :value="option.key"
                        >
                          <span
                            :class="['board-chip', { 'board-chip--active': commSelected === option.key }]"
                            role="button"
                            tabindex="0"
                            @click="selectCommsBoard(option.key)"
                            @keydown.enter.prevent="selectCommsBoard(option.key)"
                            @keydown.space.prevent="selectCommsBoard(option.key)"
                            :aria-pressed="commSelected === option.key"
                          >
                            {{ option.label }}
                          </span>
                        </v-slide-item>
                      </v-slide-group>
                    </div>

                    <div v-if="commissionerActiveCards.length > 1" class="option-bar__arrows">
                      <v-btn icon color="primary" class="mr-2" @click="prevCommissioner">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="nextCommissioner">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div
                    ref="committeeStrip"
                    class="d-flex justify-center align-center commissioner-strip mb-10"
                    :class="{
                      'commissioner-strip--grid': useGrid(commissionerVisibleCards.length, 'committees'),
                      'commissioner-strip--single': commissionerVisibleCards.length === 1
                    }"
                  >
                    <div
                      v-for="item in commissionerVisibleCards"
                      :key="item.key"
                      :class="[
                        'commissioner-thumb-wrapper',
                        'mx-3',
                        {
                          'commissioner-thumb-wrapper--active': item.role === 'current',
                          'commissioner-thumb-wrapper--inactive': item.role !== 'current'
                        },
                        `commissioner-thumb-wrapper--${item.role}`
                      ]"
                    >
                      <v-img
                        :src="require(`@/assets/${item.card.src}`)"
                        :height="imageHeight(item.role, commissionerVisibleCards.length, 'committees')"
                        :width="imageWidth(item.role, commissionerVisibleCards.length, 'committees')"
                        class="commissioner-thumb"
                        :class="[
                          item.role === 'current'
                            ? 'commissioner-thumb--active'
                            : 'commissioner-thumb--inactive',
                          execImageSlideClass(item.role)
                        ]"
                        :alt="item.card.name"
                        @click="goToCommissioner(item.index)"
                      />
                    </div>
                  </div>

                  <div class="text-center mb-4" v-if="commissionerCurrentCard">
                    <div class="text-h5 font-weight-bold mb-1">
                      {{ commissionerCurrentCard.name.toUpperCase() }}
                    </div>
                    <div class="subtitle-1 primary--text">
                      {{ commissionerCurrentCard.title }}
                    </div>
                  </div>

                  <div
                    class="px-10 py-5 text-center"
                    v-if="commissionerCurrentCard"
                    v-html="commissionerCurrentCard.detail"
                  ></div>

                </v-container>
              </v-tab-item>

              <v-tab-item>
                <v-container class="py-8 executive-section">
                  <div class="option-bar mb-6">
                    <div class="option-bar__chips chip-scroll">
                      <v-slide-group
                        v-model="directorSelected"
                        class="board-chip-slide"
                        show-arrows
                        center-active
                        mandatory
                      >
                        <v-slide-item
                          v-for="option in directorOptions"
                          :key="option.key"
                          :value="option.key"
                        >
                          <span
                            :class="['board-chip', { 'board-chip--active': directorSelected === option.key }]"
                            role="button"
                            tabindex="0"
                            @click="selectDirectorBoard(option.key)"
                            @keydown.enter.prevent="selectDirectorBoard(option.key)"
                            @keydown.space.prevent="selectDirectorBoard(option.key)"
                            :aria-pressed="directorSelected === option.key"
                          >
                            {{ option.label }}
                          </span>
                        </v-slide-item>
                      </v-slide-group>
                    </div>

                  </div>

                  <div class="director-card-grid">
                    <div
                      v-for="item in directorActiveCards"
                      :key="item.id"
                      class="director-card"
                    >
                      <div class="director-card__accent"></div>
                      <div>
                        <div class="director-card__name">{{ item.name }}</div>
                        <div class="director-card__title">{{ item.title }}</div>
                        <div
                          v-if="item.detail"
                          class="director-card__detail mt-2"
                          v-html="item.detail"
                        ></div>
                      </div>
                    </div>
                  </div>

                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionStructureOrganization",
  data() {
    return {
      activeTab: 0,
      tabs: [
        "Struktur Organisasi",
        "Manajemen",
        "Pejabat Eksekutif",
        "Internal Audit",
        "Komite Komisaris",
        "Komite Direksi"
      ],
      posts: [],
      boardOptions: [
        { key: "commissioners", label: "Komisaris" },
        { key: "directors", label: "Direksi" },
        { key: "syariah", label: "Dewan Pengawas Syariah" }
      ],
      selectedBoard: "commissioners",
      execBoardOptions: [
        { key: "secretary", label: "Corporate Secretary" },
        { key: "executive", label: "Pejabat Eksekutif" }
      ],
      commsOptions: [
        { key: "audit", label: "Komite Audit" },
        { key: "risk", label: "Komite Pemantau Resiko" },
        { key: "nomination", label: "Komite Nominasi & Remunerasi" }
      ],
      execSelected: "secretary",
      commSelected: "audit",
      directorOptions: [
        { key: "investation", label: "Komite Investasi" },
        { key: "product", label: "Komite Pengembangan Produk" },
        { key: "risk", label: "Komite Manajemen Resiko" }
      ],
      directorSelected: "investation",
      internalAuditCards: [
        { id: 1, name: 'Ahmad Rahadian', title: 'Internal Audit', src: 'ahmad-rahadian.png', detail: '<strong>Ahmad Rahadian S.E., QRMO., CIAP.</strong> Meraih gelar S1 di Fakultas Ekonomi Universitas Trisakti, Jakarta. Beliau menjabat sebagai Internal Audit PT Asuransi Takaful Umum sejak tahun 2019 dan sebelumnya pernah bekerja dalam bidang Accounting.' }
      ],
      commissionerCommitteeData: {
        audit: [
          { id: 1, name: 'Ahmad Subagyo', title: 'Ketua Komite Audit', src: 'AhmadSubagyo-nologo.png', detail: '<b>Prof. Dr. Ahmad Subagyo, S.E., M.M., CRBD.</b>  lahir di Pekalongan, 12 Februari 1972. Meraih gelar S1 di Fakultas Ekonomi dan S2 di bidang Manajemen dari Universitas Jenderal Soedirman, Purwokerto. Kemudian melanjutkan pendidikan S3 di bidang Pengkajian Ekonomi Islam di UIN Syarif Hidayatullah Jakarta. Beliau menjabat sebagai Komisaris Independen PT Asuransi Takaful Umum sekaligus sebagai Anggota Komite Nominasi dan Remunerasi serta Anggota Komite Audit.' },
          { id: 2, name: 'Armanto Witjaksono', title: 'Komite Audit', src: 'Komite-Audit-Armanto-Witjaksono.jpg', detail: '<strong>Armanto Witjaksono, S.E., Ak., M.M., C.A., Cert.DA.</strong> lahir di Bandung pada 24 Juni 1969. Meraih gelar S1 Ekonomi di bidang Akuntansi dari Universitas Padjadjaran pada tahun 1993 dan S2 Manajemen di Universitas Gadjah Mada pada tahun 1996. Karier profesionalnya dimulai sebagai auditor di Ernst & Young Jakarta, kemudian melanjutkan sebagai Accounting Analyst di 3M. Selain berpengalaman di dunia korporasi termasuk di PT Bank UFJ Indonesia dan MUFG Jakarta Branch, ia juga aktif di dunia akademik sebagai dosen di Universitas Bina Nusantara dan dosen tamu di Universitas Padjadjaran. Sejak 1 September 2019, beliau menjabat sebagai anggota Komite Audit PT Asuransi Takaful Umum.' },
          { id: 3, name: 'Ainul Hidayati', title: 'Komite Audit', src: 'Komite-Audit-Ainul-Hidayati.jpg', detail: '<strong>Ainul Hidayati, S.Si., AAAIK. </strong> lahir di Jakarta dan meraih gelar Sarjana Sains di bidang Matematika (Statistika) dari Universitas Indonesia pada tahun 2003, serta gelar profesional Ajun Ahli Asuransi Indonesia Kerugian (AAAIK) dari AAMAI pada tahun 2006. Berpengalaman lebih dari 15 tahun di industri asuransi umum, khususnya di bidang underwriting, reasuransi fakultatif dan treaty, serta pengembangan produk. Karier profesionalnya dimulai dari program Management Trainee di PT Asuransi Takaful Umum hingga menjabat sebagai Head of Reinsurance, kemudian melanjutkan kariernya sebagai Head of Reinsurance Department di PT Asuransi Samsung Tugu. Saat ini, beliau menjabat sebagai anggota Komite Audit PT Asuransi Takaful Umum sejak 17 April 2025.' },
        ],
        risk: [
          { id: 1, name: 'Ricky Avicenna', title: 'Ketua Komite Pemantau Risiko', src: 'RickyAvicenna-nologo.png', detail: '<b>Ricky Avicenna, S.E., QIP, AAAIK, AIIS, CRMP.</b> lahir di Langsa, 18 Mei 1979. Menempuh pendidikan S1 Fakultas Ekonomi Universitas Indonesia pada tahun 2001. Beliau menjabat sebagai Komisaris Independen PT Asuransi Takaful Umum sejak tahun 2018 sekaligus sebagai Ketua Komite Pemantau Risiko dan Anggota Komite Nominasi dan Remunerasi PT Asuransi Takaful Umum.' },
          { id: 2, name: 'Muhammad Rommy Aniswar', title: 'Sekretaris Komite Pemantau Risiko', src: 'Muhammad-Rommy-Aniswar.png', detail: '<strong>Muhammad Rommy Aniswar S.H., QCRO.</strong> Menempuh pendidikan Sarjana Hukum di Universitas Jenderal Soedirman. Saat ini menjabat sebagai Anggota Komite Pengembangan Produk serta Risk Management & Compliance Specialist di PT Asuransi Takaful Umum. Berpengalaman dalam bidang kepatuhan, manajemen risiko, dan audit di industri asuransi dan lembaga keuangan.' },
          { id: 3, name: 'Maryana', title: 'Anggota Komite Pemantau Risiko', src: 'Maryana.png', detail: '<strong>Maryana, S.E., ERMAP, CRO.</strong> Meraih gelar Akuntansi dari Universitas Indonesia tahun 2008. Saat ini menjabat sebagai Anggota Komite Investasi dan Finance Division Head PT Asuransi Takaful Umum. Beliau memiliki pengalaman yang kuat di bidang keuangan, treasury, dan akuntansi serta pernah menduduki beberapa posisi manajerial strategis di perusahaan.' },
        ],
        nomination: [
          { id: 1, name: 'Ahmad Subagyo', title: 'Ketua Komite Nominasi dan Remunerasi', src: 'AhmadSubagyo-nologo.png', detail: '<strong>Prof. Dr. Ahmad Subagyo, S.E., M.M., CRBD.</strong>  lahir di Pekalongan, 12 Februari 1972. Meraih gelar S1 di Fakultas Ekonomi dan S2 di bidang Manajemen dari Universitas Jenderal Soedirman, Purwokerto. Kemudian melanjutkan pendidikan S3 di bidang Pengkajian Ekonomi Islam di UIN Syarif Hidayatullah Jakarta. Beliau menjabat sebagai Komisaris Independen PT Asuransi Takaful Umum sekaligus sebagai Anggota Komite Nominasi dan Remunerasi serta Anggota Komite Audit.' },
          { id: 1, name: 'Ricky Avicenna', title: 'Anggota Komite Nominasi dan Remunerasi', src: 'RickyAvicenna-nologo.png', detail: '<strong>Ricky Avicenna, S.E., QIP, AAAIK, AIIS, CRMP.</strong> lahir di Langsa, 18 Mei 1979. Menempuh pendidikan S1 Fakultas Ekonomi Universitas Indonesia pada tahun 2001. Beliau menjabat sebagai Komisaris Independen PT Asuransi Takaful Umum sejak tahun 2018 sekaligus sebagai Ketua Komite Pemantau Risiko dan Anggota Komite Nominasi dan Remunerasi PT Asuransi Takaful Umum.' },
          { id: 3, name: 'Ahmad Rojib Karimi', title: 'Anggota Komite Nominasi dan Remunerasi', src: 'Ahmad-Rojib-Karimi.png', detail: '<strong>Ahmad Rojib Karimi, S.Psi., CHRP, CRO.</strong> Menempuh pendidikan S1 Psikologi di Universitas Islam Negeri Syarif Hidayatullah Jakarta. Saat ini beliau menjabat sebagai Human Capital & General Affair Department Head dan Anggota Komite Nominasi dan Remunerasi PT Asuransi Takaful Umum. Memiliki pengalaman profesional di bidang sumber daya manusia dan general affairs, baik di industri asuransi maupun manufaktur, dengan rekam jejak yang mencakup posisi supervisor hingga analis pengembangan SDM.' }
        ]
      },
      directorCommitteeData: {
        investation: [
          { id: 1, name: 'Darojat Yogi Candra', title: 'Ketua Komite Investasi ', src: '', detail: '<strong>Darojat Yogi Candra, S.E.As., AAAIK, AIIS, CRMO. </strong> lahir di Purbalingga, 6 Januari 1979. Diangkat sebagai Direktur Operasional berdasarkan Keputusan Anggota Dewan Komisioner OJK Nomor KEP-40/NB.21/2022 tanggal 19 Agustus 2022. Selain itu, beliau juga menjabat sebagai Ketua Komite Investasi PT Asuransi Takaful Umum. Memiliki latar belakang pendidikan S1 Manajemen Asuransi Syariah dari STMA Trisakti.'},
          { id: 2, name: 'Tri Eko Handayaningsih', title: 'Anggota Komite Investasi', src: '', detail: '<strong>Tri Eko Handayaningsih, S.M., FSAI, AAIJ, FIIS, CRO.</strong> Menyelesaikan pendidikan sarjana Manajemen Risiko di STIMRA Jakarta. Saat ini menjabat sebagai Sekretaris Komite Pengembangan Produk serta Kepala Divisi Aktuaria dan Aktuaris Perusahaan PT Asuransi Takaful Umum. Beliau memiliki pengalaman panjang di bidang aktuaria, termasuk pernah menjabat sebagai Aktuaris Perusahaan di PT Asuransi Jiwa Syariah Bumiputera dan Kepala Divisi Aktuaria di PT Asuransi Takaful Keluarga.' },
          { id: 3, name: 'Asep Saehuna', title: 'Anggota Komite Investasi', src: '', detail: '<strong>Asep Saehuna, S.E., M.Si.</strong> Meraih gelar Magister Akuntansi dari Universitas Trisakti. Menjabat sebagai Anggota Komite Investasi dan Head of Credit Control & Treasury Department PT Asuransi Takaful Umum. Berpengalaman luas dalam bidang treasury, finance, credit control, serta manajemen layanan dan human capital.' },
          { id: 4, name: 'Maryana', title: 'Anggota Komite Investasi', src: '', detail: '<strong>Maryana, S.E., ERMAP, CRO.</strong> Meraih gelar Akuntansi dari Universitas Indonesia tahun 2008. Saat ini menjabat sebagai Anggota Komite Investasi dan Finance Division Head PT Asuransi Takaful Umum. Beliau memiliki pengalaman yang kuat di bidang keuangan, treasury, dan akuntansi serta pernah menduduki beberapa posisi manajerial strategis di perusahaan.' },
          { id: 5, name: 'Nuri Tri Susanti', title: 'Anggota Komite Investasi', src: '', detail: '<strong>Nuri Tri Susanti, S.E., MMSI., CFMA.</strong> Menempuh pendidikan Sarjana Akuntansi dari Universitas Indonesia. Saat ini menjabat sebagai Anggota Komite Manajemen Risiko serta Accounting & Investment Department Head PT Asuransi Takaful Umum. Berpengalaman dalam bidang akuntansi, investasi, dan reasuransi, serta pernah menduduki berbagai posisi manajerial di Takaful Umum dan perusahaan lainnya.' }
        ],
        product: [
          { id: 1, name: 'Ihrom Bayu Aji', title: 'Ketua Komite Pengembangan Produk', src: '', detail: '<strong>Ihrom Bayu Aji, S.T., AAIK, Dipl. Ins., AIIS, CRMP, QIP, IPGD-GI. </strong> lahir di Jakarta, 3 Februari 1977. Diangkat sebagai Direktur Utama berdasarkan Keputusan Anggota Dewan Komisioner Otoritas Jasa Keuangan tentang Hasil Penilaian Kemampuan dan Kepatutan Nomor KEP-298/NB.02/2023 tanggal 14 Juni 2023. Beliau juga menjabat sebagai Komite Pengembangan Produk di PT Asuransi Takaful Umum. Pendidikan terakhir S1 Sarjana Teknik Metalurgi Universitas Indonesia Tahun 2000. Saat ini beliau juga aktif sebagai Anggota Bidang Asuransi Kerugian AAMAI periode 2022-2025.' },
          { id: 2, name: 'Tri Eko Handayaningsih', title: 'Sekretaris Komite Pengembangan Produk', src: '', detail: '<strong>Tri Eko Handayaningsih, S.M., FSAI, AAIJ, FIIS, CRO.</strong> Menyelesaikan pendidikan sarjana Manajemen Risiko di STIMRA Jakarta. Saat ini menjabat sebagai Sekretaris Komite Pengembangan Produk serta Kepala Divisi Aktuaria dan Aktuaris Perusahaan PT Asuransi Takaful Umum. Beliau memiliki pengalaman panjang di bidang aktuaria, termasuk pernah menjabat sebagai Aktuaris Perusahaan di PT Asuransi Jiwa Syariah Bumiputera dan Kepala Divisi Aktuaria di PT Asuransi Takaful Keluarga.' },
          { id: 3, name: 'Sutrimo', title: 'Anggota  Komite Pengembangan Produk', src: '', detail: '<strong>Sutrimo, S.Kom, AAIK, APAI, CIIB, CRGP, FIIS, ICBU, QIP.</strong> Lulus Sarjana Teknik Informatika dari Universitas Dian Nuswantoro Semarang. Menjabat sebagai Claim & Research Division Head dan Head of SBU Suretyship dan Anggota Komite Pengembangan Produk PT Asuransi Takaful Umum. Beliau memiliki pengalaman luas di bidang teknik, klaim, dan pengembangan produk.' },
          { id: 4, name: 'Muhammad Rommy Aniswar', title: 'Anggota  Komite Pengembangan Produk', src: '', detail: '<strong>Muhammad Rommy Aniswar S.H., QCRO.</strong> Menempuh pendidikan Sarjana Hukum di Universitas Jenderal Soedirman. Saat ini menjabat sebagai Anggota Komite Pengembangan Produk serta Risk Management & Compliance Specialist di PT Asuransi Takaful Umum. Berpengalaman dalam bidang kepatuhan, manajemen risiko, dan audit di industri asuransi dan lembaga keuangan.' },
          { id: 5, name: 'Ulfatul Layla', title: 'Anggota  Komite Pengembangan Produk', src: '', detail: '<strong>Ulfatul Layla, S.E., AAAIK., CRO.</strong> Menyelesaikan pendidikan Manajemen Risiko dan Asuransi di STIMRA Jakarta. Menjabat sebagai Anggota Komite Pengembangan Produk serta Underwriting & Retakaful Department Head PT Asuransi Takaful Umum. Memiliki pengalaman profesional di bidang underwriting, retakaful, klaim, dan financial insurance.' },
          { id: 6, name: 'Abdul Ajis Rifai', title: 'Anggota  Komite Pengembangan Produk', src: '', detail: '<strong>Abdul Ajis Rifai A.Md.As.</strong> Menempuh pendidikan Manajemen Risiko dan Asuransi di STIMRA Jakarta. Saat ini menjabat sebagai Anggota Komite Pengembangan Produk dan Branch Coordinator Manager PT Asuransi Takaful Umum. Berpengalaman di bidang pemasaran, perbankan, dan underwriting asuransi syariah.' },
          { id: 7, name: 'Fajar Nindyo', title: 'Anggota  Komite Pengembangan Produk', src: '', detail: '<strong>Fajar Nindyo, S.T., AAAIK, ICMo.U, ICPU., ICEU., CRO.</strong> Pendidikan S1 Teknik Sipil dari Institut Teknologi Bandung. Menjabat sebagai Anggota Komite Pengembangan Produk, Risk Engineering Specialist dan Wakil Manager Takaful Institute PT Asuransi Takaful Umum. Memiliki pengalaman dalam bidang Underwriting dan Marketing Officer Manager.' }
        ],
        risk: [
          { id: 1, name: 'R. Melda Maesarach', title: 'Ketua Komite Manajemen Risiko', src: 'IhromBayu-nologo.png', detail: '<strong>R. Melda Maesarach, S.Pd., M.Si., AIIS, CRMP.</strong>  lahir di Bandung, 9 Mei 1976. Menempuh pendidikan S1 di Universitas Pasundan Bandung dan S2 Magister Keuangan Syariah di STIE Ahmad Dahlan Jakarta pada tahun 2014. Aktif sebagai Dosen Prodi Ekonomi Islam Fakultas Ekonomi Bisnis Universitas Muhammadiyah Jakarta hingga sekarang. Saat ini, beliau menjabat sebagai Sekretaris Perusahaan, Ketua Komite Manajemen Risiko, serta Direktur Kepatuhan PT Asuransi Takaful Umum.' },
          { id: 2, name: 'Muhammad Rommy Aniswar', title: 'Sekretaris Komite Manajemen Risiko', src: '', detail: '<strong>Muhammad Rommy Aniswar S.H., QCRO.</strong> Menempuh pendidikan Sarjana Hukum di Universitas Jenderal Soedirman. Saat ini menjabat sebagai Anggota Komite Pengembangan Produk serta Risk Management & Compliance Specialist di PT Asuransi Takaful Umum. Berpengalaman dalam bidang kepatuhan, manajemen risiko, dan audit di industri asuransi dan lembaga keuangan.' },
          { id: 3, name: 'Darojat Yogi Candra', title: 'Anggota Komite Manajemen Risiko', src: '', detail: '<strong>Darojat Yogi Candra, S.E.As., AAAIK, AIIS, CRMO. </strong> lahir di Purbalingga, 6 Januari 1979. Diangkat sebagai Direktur Operasional berdasarkan Keputusan Anggota Dewan Komisioner OJK Nomor KEP-40/NB.21/2022 tanggal 19 Agustus 2022. Selain itu, beliau juga menjabat sebagai Ketua Komite Investasi PT Asuransi Takaful Umum. Memiliki latar belakang pendidikan S1 Manajemen Asuransi Syariah dari STMA Trisakti.' },
          { id: 4, name: 'Nakulo Setyo Handoko', title: 'Anggota Komite Manajemen Risiko', src: '', detail: '<strong>Nakulo Setyo Handoko, S.E., CRO.</strong> Menyelesaikan pendidikan Sarjana Ekonomi di Universitas Widya Gama Malang. Saat ini menjabat sebagai Anggota Komite Manajemen Risiko PT Asuransi Takaful Umum serta Claim Motor Vehicle & General Accident Department Head. Beliau memiliki pengalaman panjang di bidang klaim, pengembangan cabang, dan manajemen bisnis di PT Asuransi Takaful Umum sejak 1998.' },
          { id: 5, name: 'Yossy Biyantariska', title: 'Anggota Komite Manajemen Risiko', src: '', detail: '<strong>Yossy Biyantariska, S.E., CRO.</strong> Meraih gelar Sarjana Akuntansi dari UPN Veteran Yogyakarta. Menjabat sebagai Anggota Komite Manajemen Risiko dan Division Head Corporate Business di PT Asuransi Takaful Umum. Beliau memiliki pengalaman signifikan dalam manajemen cabang dan pemasaran di industri asuransi dan perbankan.' },
          { id: 6, name: 'Nuri Tri Susanti', title: 'Anggota Komite Manajemen Risiko', src: '', detail: '<strong>Nuri Tri Susanti, S.E., MMSI., CFMA.</strong> Menempuh pendidikan Sarjana Akuntansi dari Universitas Indonesia. Saat ini menjabat sebagai Anggota Komite Manajemen Risiko serta Accounting & Investment Department Head PT Asuransi Takaful Umum. Berpengalaman dalam bidang akuntansi, investasi, dan reasuransi, serta pernah menduduki berbagai posisi manajerial di Takaful Umum dan perusahaan lainnya.' }
        ]
      },
      boardData: {
        commissioners: [
          { id:1, name: 'Bahroji', title: 'Komisaris Utama', src: 'Bahrodji-nologo.png',detail: '<strong>Drs. H. Bahroji, M.M.</strong> Menjabat sebagai Komisaris Utama PT Asuransi Takaful Umum sejak tahun 2018 dan menjadi Wakil Bendahara Umum Koperasi Simpan Pinjam Jasa sejak tahun 2020. Beliau merupakan pemegang 9,52% saham di PT Asuransi Takaful Umum. <br><br> <strong>Drs. H. Bahroji, M.M.</strong> lahir di Tegal, 4 Desember 1960. Beliau meraih gelar Sarjana Ilmu Sosial dan Ilmu Politik dari Universitas Pancasakti pada tahun 1988, dan gelar Magister di bidang Manajemen dari Universitas Jenderal Soedirman pada tahun 1998. <br><br> Karirnya dimulai sebagai Kepala Divisi Treasury dan Pengembangan Usaha, Koperasi Simpan Pinjam Jasa (1987 - 2014), kemudian menjadi Bendahara II Koperasi Simpan Pinjam Jasa (2015 - 2020). Pada tahun 2010 - 2020 menjadi Direktur Utama PT Jasa Investindo sekaligus Komisaris PT Jasa Utama Capital. Kemudian menjadi Direktur Utama PT Mega Surya Investa (2014 - 2021). Pada tahun 2014 hingga sekarang menjadi Direktur PT Texin Permata Husada. Menjadi Direktur Utama PT Jasa Prima Investa (2015 - sekarang).' },
          { id:2, name: 'Ahmad Subagyo', title: 'Komisaris Independen', src: 'AhmadSubagyo-nologo.png', detail: '<strong>Prof. Dr. Ahmad Subagyo, S.E., M.M., CRBD.</strong> menjabat sebagai Komisaris Independen dan Ketua Komite Audit PT Asuransi Takaful Umum sejak tahun 2018, dilanjutkan pada tahun 2025 juga menjabat sebagai Ketua Komite Nominasi dan Remunerasi. <br><br> <strong>Prof. Dr. Ahmad Subagyo, S.E., M.M., CRBD.</strong> lahir di Pekalongan, 12 Februari 1972. Meraih gelar S1 di Fakultas Ekonomi dan S2 di bidang Manajemen dari Universitas Jenderal Soedirman, Purwokerto. Kemudian melanjutkan pendidikan S3 di bidang Pengkajian Ekonomi Islam di UIN Syarif Hidayatullah Jakarta. Beliau menjabat sebagai Komisaris Independen PT Asuransi Takaful Umum sekaligus sebagai Anggota Komite Nominasi dan Remunerasi serta Anggota Komite Audit. <br><br>Karir beliau dimulai sebagai Manajer Keuangan PT Bangun Pusaka Bekasi pada tahun 2004, kemudian menjabat sebagai Direktur PT Bank Perkreditan Rakyat Tritama Lumbung Cemerlang Tangerang (2005–2007) dan Konsultan Bank BPD Aceh Syariah (2008–2009). Sejak 2011, beliau aktif sebagai konsultan internasional di bidang keuangan mikro dan koperasi, termasuk sebagai konsultan World Bank (2011–2020), konsultan Japan International Cooperation Agency/JICA (2013–2015), serta bergabung dengan EGSA-USAID (2020–2022), dan sejak 2022 menjadi peneliti pada International Labour Organization (ILO) Jakarta. Beliau juga pernah menjadi Anggota Komite Dewan Komisaris PT Pupuk Kujang (2013–2018). Selain kiprah internasional, beliau pernah berkarier di Kospin JASA Pekalongan, mendirikan Yayasan Kemandirian Perkooperasian Indonesia (YAKKIN), menjadi inisiator Asosiasi LKM Indonesia (ASLINDO), serta sejak 2023 menjabat Wakil Rektor IKOPIN University dan Profesor Ilmu Manajemen di Sekolah Tinggi Ilmu Ekonomi Gici Business School.' },
          { id:3, name: 'Ricky Avicenna', title: 'Komisaris Independen', src: 'RickyAvicenna-nologo.png', detail: '<strong>Ricky Avicenna, S.E., QIP, AAAIK, AIIS, CRMP.</strong> Menjabat sebagai Komisaris Independen dan Ketua Komite Pemantau Risiko Umum PT Asuransi Takaful sejak tahun 2019. Beliau juga menjabat sebagai Anggota Komite Nominasi dan Remunerasi PT Asuransi Takaful Umum sejak 2025. <br><br> <strong>Ricky Avicenna, S.E., QIP, AAAIK, AIIS, CRMP. </strong> lahir di Langsa, 18 Mei 1979. Menempuh pendidikan S1 Fakultas Ekonomi Universitas Indonesia pada tahun 2001. <br><br> Karirnya dimulai sebagai Reinsurance and Underwriting Officer PT Asuransi Takaful Umum (2004 – 2007). Kemudian menjadi Compliance & KYCU Manager PT Asuransi Takaful Umum (2007 - 2013) dan menjadi Head of Corporate Strategic PT Asuransi Takaful Umum (2013 - 2014)' },
        ],
        directors: [
          { id:1, name: 'Ihrom Bayu Aji', title: 'Direktur Utama', src: 'IhromBayu-nologo.png', detail: '<strong>Ihrom Bayu Aji, S.T., AAIK, Dipl. Ins., AIIS, CRMP, QIP, IPGD-GI. </strong> menjabat sebagai Direktur Utama PT Asuransi Takaful Umum berdasarkan Keputusan Anggota Dewan Komisioner Otoritas Jasa Keuangan tentang Hasil Penilaian Kemampuan dan Kepatutan Nomor KEP-298/NB.02/2023 sejak 2023, sekaligus menjadi Ketua Komite Pengembangan Produk sejak 2024. <br><br><strong>Ihrom Bayu Aji, S.T., AAIK, Dipl. Ins., AIIS, CRMP, QIP, IPGD-GI. </strong> lahir di Jakarta, 3 Februari 1977. Memperoleh gelar Sarjana Teknik Metalurgi Universitas Indonesia Tahun 2000 dan gelar Magister di bidang General Insurance dari Institute of Insurance and Risk Management, Hyderabad, India, pada tahun 2005. <br><br> Karirnya dimulai sebagai Management Trainee PT Asuransi Umum Bumiputeramuda 1967 (2001 - 2003), kemudian menjadi Technical Junior Manager (2003 - 2005), lalu menjadi Head of Underwriting Department pada (2005 - 2009). Pada tahun 2009 menjadi Technical Advisor  dan pada 2009 - 2011 menjadi Head of Inward Reinsurance Department Manager di perusahaan yang sama. Selanjutnya, menjadi Tenaga Ajun Ahli Asuransi Syariah (2012 - 2014) dan menjadi General Manager (2014–2017). Kemudian beliau menjadi Technical Advisor di PT Asuransi Takaful Umum (2018 - 2019), lanjut menjadi Tenaga Ahli Syariah (2019 - sekarang), dan pada tahun 2019 - 2023 menjadi Direktur Teknik. Beliau juga aktif sebagai Anggota Bidang Asuransi Kerugian AAMAI periode 2022-2025.' },
          { id:2, name: 'R. Melda Maesarach', title: 'Direktur Kepatuhan', src: 'Melda-nologo.png', detail: '<strong>R. Melda Maesarach, S.Pd., M.Si., AIIS, CRMP.</strong> menjabat sebagai Direktur Kepatuhan PT Asuransi Takaful Umum sejak 2020, beliau juga menjabat Ketua Komite Manajemen Risiko sejak 2022, dan menjadi Sekretaris Perusahaan sejak 2024 di PT Asuransi Takaful Umum. <br><br> <strong>R. Melda Maesarach, S.Pd., M.Si., AIIS, CRMP.</strong> lahir di Bandung, 9 Mei 1976. Menempuh S1 pendidikan akuntansi di Universitas Pasundan Bandung tahun 1988 dan S2 Magister Keuangan Syariah di STIE Ahmad Dahlan Jakarta pada tahun 2015. Aktif sebagai Dosen Prodi Ekonomi Islam Fakultas Ekonomi Bisnis Universitas Muhammadiyah Jakarta sejak 2010 hingga sekarang. <br> <br> Karirnya dimulai sebagai Finance Cabang Bandung PT Asuransi Takaful Umum (1997 - 2003), menjadi Finance Asst. Manager Cabang Jakarta Pondok Indah (2003 - 2011), kemudian menjadi Asst. Manager Accounting & Reinsurance (2011 - 2014), selanjutnya menjadi Head of Accounting (2014 - 2017), menjadi  Finance & HR Group Head (2018 - 2019), menjadi di perusahaan yang sama. Selanjutnya, menjadi Risk Management & Corporate Strategic (2019 - 2020) di PT Asuransi Takaful Umum. ' },
          { id:3, name: 'Darojat Yogi Candra', title: 'Direktur Operasional', src: 'DarojatYogi-nologo.png', detail: '<strong>Darojat Yogi Candra, S.E.As., AAAIK, AIIS, CRMO. </strong> menjabat sebagai Direktur Operasional berdasarkan Keputusan Anggota Dewan Komisioner OJK Nomor KEP-40/NB.21/2022 tanggal 19 Agustus 2022, sekaligus menjabat sebagai Ketua Komite Investasi PT Asuransi Takaful Umum sejak tahun 2022 hingga sekarang. <br><br> <strong>Darojat Yogi Candra, S.E.As., AAAIK, AIIS, CRMO. </strong> lahir di Purbalingga, 6 Januari 1979. Memperoleh gelar Diploma Tiga (D3) Asuransi Kerugian dari Akademi Asuransi Trisakti (AKASTIRI) pada tahun 2000, gelar Sarjana di bidang Manajemen Asuransi Syariah dari Sekolah Tinggi Manajemen Asuransi Trisakti (STMA) pada tahun 2011. <br><br> Karirnya dimulai sebagai Tenaga Admin Teknik Underwriting Marine PT Staco Jasapratama general Insurance (2001 - 2003). Selanjutnya menjadi Staff Underwriting (Marine) PT Asuransi Asei Indonesia d/h PT Asuransi Ekspor Indonesia (Persero) (2003 - 2004), menjadi Staff Teknik dan Pemasaran Cabang Surabaya (2005 - 2007), menjadi Staff Underwriting (Marine) (2007 - 2009), dan menjadi Kepala Seksi Teknik dan Pemasaran Cabang Bandung. Pada tahun 2012, beliau menjadi Kepala Seksi Underwriting Asuransi Umum PT Asuransi Asei Indonesia d/h PT Asuransi Ekspor Indonesia (Persero), kemudian menjadi Kepala Bagian Underwriting Suretyship (2012 - 2013), selanjutnya menjadi Kepala Unit Syariah (2013 - 2017), dan menjadi Plt Kepala Divisi Asuransi Umum (2017 - 2019). Kemudian beliau berkarir di PT Asuransi Takaful Umum menjadi Underwriting & Retakaful Department Head (2019 - 2020), menjadi Pjs. Direktur teknik (2020 - 2021), selanjutnya menjadi Underwriting & Retakaful Group Head (2021 - 2022).' },
        ],
        syariah: [
          { id:1, name: 'Anwar Abbas', title: 'Ketua Dewan Pengawas Syariah', src: 'AnwarAbbas-nologo.png',detail:'<strong>DR. H. Anwar Abbas, M.M., M.Ag.</strong> menjabat sebagai Ketua Dewan Pengawas Syariah PT Asuransi Takaful Umum sejak tahun 2014. <br><br> <strong>DR. H. Anwar Abbas, M.M., M.Ag.</strong> lahir di Balaimansiro, 15 Februari 1955. Beliau meraih gelar Sarjana Tarbiyah – Bahasa Arab dari UIN Syarif Hidayatullah pada tahun 1982, gelar Magister Manajemen – Marketing dari STIE-IPWI Jakarta pada tahun 1997, gelar Magister Agama – Ekonomi Islam dari Universitas Muhammadiyah Jakarta pada tahun 1999, dan gelar Doktor di bidang Pemikiran Islam dari UIN Syarif Hidayatullah Jakarta tahun 2008. <br><br> Karirnya dimulai sebagai Wakil Rektor II (1986 - 1991) dan menjadi Wakil Rektor IV IKIP Muhammadiyah Jakarta (Sekarang UHAMKA) (1991 - 1995). Kemudian menjadi Anggota Majelis Permusyawaratan Rakyat Republik Indonesia (1997 - 1999). Beliau menjadi Vice President (1999 - 2004) dan Deputy General Secretary (2004 - 2009) International Islamic Confederation of Labour (IICL). Selanjutnya, beliau menjadi Direktur Bidang Agama & Pemasaran (1998 - 2001) dan Direktur Bidang Agama & SDM (2004 - 2020) Rumah Sakit Islam Pondok Kopi Jakarta. Pada tahun 2005 - 2010 menjadi Sekretaris sekaligus Ketua DPP Majelis Ulama Indonesia (MUI) Pusat. Pada tahun 2006 - 2010 menjadi Bendahara sekaligus Ketua Majelis Ekonomi dan Kewirausahaan Pimpinan Pusat Muhammadiyah. Beliau menjadi Ketua Bidang Pemberdayaan Ekonomi Umat Majelis Ulama Indonesia (MUI) (2010 - 2015). Kemudian menjadi Ketua Dewan Pengawas Syariah PT AJS Jasa Mitra Abadi Tbk (2015 - 2024). Saat ini, beliau menjabat sebagai Ketua Bidang UMKM, Pemberdayaan & Lingkungan, PP Muhammadiyah sejak tahun 2022, dan menjadi Wakil Ketua Umum Majelis Ulama Indonesia (MUI) sejak tahun 2020.' },
          { id:2, name: 'Amin Musa', title: 'Anggota Dewan Pengawas Syariah', src: 'AminMusa-nologo.png',detail:'<strong>Amin Musa, S.E., QRMA.</strong> menjabat sebagai Anggota Dewan Pengawas Syariah PT Asuransi Takaful Umum sejak tahun 2022 <br><br> <strong>Amin Musa, S.E., QRMA.</strong> lahir di Pemalang, 19 April 1963. Beliau meraih gelar S1 di bidang Akuntansi dari Sekolah Tinggi Ilmu Ekonomi Indonesia pada tahun 2002 <br><br> Karirnya dimulai sebagai Dewan Pengawas Syariah PT Asuransi Bintang Tbk (2017 - 2021). Kemudian menjadi Anggota Komite Audit PT AJS Jasa Mitra Abadi Tbk (2017 - 2022) dan menjadi Dewan Pengawas Syariah PT AJS Amanah Giri Artha (2016 - 2024). Saat ini, beliau menjadi Dewan Pengawas Syariah PT Jasa Gadai Syariah sejak tahun 2017, menjadi Dewan Pengawas Syariah DPLK Allianz Indonesia sejak tahun 2021, dan menjadi Anggota Dewan Pengawas Syariah PT AXA Mandiri Div. Syariah sejak tahun 2024.' },
        ]
      },
      executiveData: {
        secretary: [
          { id:1, name: 'R. Melda Maesarach', title: 'Sekretaris Perusahaan', src: 'Melda-nologo.png', detail: '<strong>R. Melda Maesarach, S.Pd., M.Si., AIIS, CRMP.</strong> lahir di Bandung, 9 Mei 1976. Menempuh pendidikan S1 di Universitas Pasundan Bandung dan S2 Magister Keuangan Syariah di STIE Ahmad Dahlan Jakarta pada tahun 2014. Aktif sebagai Dosen Prodi Ekonomi Islam Fakultas Ekonomi Bisnis Universitas Muhammadiyah Jakarta hingga sekarang. Saat ini, beliau menjabat sebagai Sekretaris Perusahaan, Ketua Komite Manajemen Risiko, serta Direktur Kepatuhan PT Asuransi Takaful Umum.' },
        ],
        executive: [
          { id:1, name: 'Yossy Biyantariska', title: 'Corporate Division Head', src: 'Yossy-Biyantariska.png', detail: '<strong>Yossy Biyantariska, S.E., CRO.</strong> Meraih gelar Sarjana Akuntansi dari UPN Veteran Yogyakarta. Menjabat sebagai Anggota Komite Manajemen Risiko dan Division Head Corporate Business di PT Asuransi Takaful Umum. Beliau memiliki pengalaman signifikan dalam manajemen cabang dan pemasaran di industri asuransi dan perbankan.' },
          { id:2, name: 'Sutrimo', title: 'Head Of Strategic Business Unit Suretyship Syariah', src: 'Sutrimo.png', detail: '<strong>Sutrimo, S.Kom, AAIK, APAI, CIIB, CRGP, FIIS, ICBU, QIP.</strong> Lulus Sarjana Teknik Informatika dari Universitas Dian Nuswantoro Semarang. Menjabat sebagai Claim & Research Division Head dan Head of SBU Suretyship dan Anggota Komite Pengembangan Produk PT Asuransi Takaful Umum. Beliau memiliki pengalaman luas di bidang teknik, klaim, dan pengembangan produk.' },
          { id:3, name: 'Tri Eko Handayaningsih', title: 'Actuary Division Head', src: 'Tri-Eko-Handayaningsih.png', detail: '<strong>Tri Eko Handayaningsih, S.M., FSAI, AAIJ, FIIS, CRO.</strong> Menyelesaikan pendidikan sarjana Manajemen Risiko di STIMRA Jakarta. Saat ini menjabat sebagai Sekretaris Komite Pengembangan Produk serta Kepala Divisi Aktuaria dan Aktuaris Perusahaan PT Asuransi Takaful Umum. Beliau memiliki pengalaman panjang di bidang aktuaria, termasuk pernah menjabat sebagai Aktuaris Perusahaan di PT Asuransi Jiwa Syariah Bumiputera dan Kepala Divisi Aktuaria di PT Asuransi Takaful Keluarga.' },
          { id:4, name: 'Maryana', title: 'Finance Division Head', src: 'Maryana.png', detail: '<strong>Maryana, S.E., ERMAP, CRO.</strong> Meraih gelar Sarjana Akuntansi dari Universitas Indonesia tahun 2008. Saat ini menjabat sebagai Anggota Komite Investasi dan Finance Division Head PT Asuransi Takaful Umum. Beliau memiliki pengalaman yang kuat di bidang keuangan, treasury, dan akuntansi serta pernah menduduki beberapa posisi manajerial strategis di perusahaan.' },
        ]
      },
      currentIndex: 0,
      isReverse: false,
      structureImage: require("@/assets/structure-organization.jpg"),
      managementGroups: [
        {
          slug: "boc",
          tag: "BOC",
          title: "Dewan Komisaris",
          members: [
            { name: "R. Pratama", role: "Komisaris Utama" },
            { name: "S. Mahendra", role: "Komisaris Independen" }
          ]
        },
        {
          slug: "dps",
          tag: "DPS",
          title: "Dewan Pengawas Syariah",
          members: [
            { name: "A. Rahman", role: "Ketua" },
            { name: "M. Yusuf", role: "Anggota" }
          ]
        },
        {
          slug: "bod",
          tag: "BOD",
          title: "Dewan Direksi",
          members: [
            { name: "D. Lestari", role: "Direktur Utama" },
            { name: "H. Putra", role: "Direktur Operasional" },
            { name: "V. Hartono", role: "Direktur Keuangan" }
          ]
        }
      ],
      executives: [
        {
          name: "Aria Lestari",
          position: "Chief Risk Officer",
          unit: "Manajemen Risiko",
          contact: "aria.lestari@perusahaan.com"
        },
        {
          name: "Bagus Satya",
          position: "Chief Information Officer",
          unit: "Teknologi Informasi",
          contact: "bagus.satya@perusahaan.com"
        },
        {
          name: "Clara Nadine",
          position: "Chief Marketing Officer",
          unit: "Pengembangan Bisnis",
          contact: "clara.nadine@perusahaan.com"
        }
      ],
      execIndex: 0,
      execIsReverse: false,
      internalIndex: 0,
      internalIsReverse: false,
      commissionerIndex: 0,
      commissionerIsReverse: false,
      directorIndex: 0,
      directorIsReverse: false
    };
  },
  computed: {
    currentCard () {
      return this.activeCards[this.currentIndex] || null
    },

    // Selalu kembalikan 3 kartu: prev, current, next
    visibleCards () {
      const n = this.activeCards.length
      if (!n) return []
      const current = this.currentIndex

      const useListLayout =
        (this.selectedBoard === 'syariah' && n >= 2) ||
        (this.selectedBoard !== 'syariah' && n >= 3)

      if (useListLayout) {
        return this.activeCards.map((card, index) => ({
          key: `${this.selectedBoard}-${card.id || index}`,
          card,
          index,
          role: index === current ? 'current' : 'list'
        }))
      }

      if (n === 1) {
        return [
          {
            key: 'current',
            card: this.activeCards[current],
            index: current,
            role: 'current'
          }
        ]
      }

      if (n === 2) {
        const other = (current + 1) % 2
        return [
          {
            key: 'current',
            card: this.activeCards[current],
            index: current,
            role: 'current'
          },
          {
            key: 'peek',
            card: this.activeCards[other],
            index: other,
            role: 'peek'
          }
        ]
      }

      return []
    },

    activeCards () {
      return this.boardData[this.selectedBoard] || []
    },

    execCurrentCard () {
      return this.execActiveCards[this.execIndex] || null
    },

    execActiveCards () {
      return this.executiveData[this.execSelected] || []
    },

    execVisibleCards () {
      const n = this.execActiveCards.length
      if (!n) return []
      const current = this.execIndex

      if (n >= 3) {
        return this.execActiveCards.map((card, index) => ({
          key: `${this.execSelected}-${card.id || index}`,
          card,
          index,
          role: index === current ? 'current' : 'list'
        }))
      }

      if (n === 1) {
        return [
          { key: 'current', card: this.execActiveCards[current], index: current, role: 'current' }
        ]
      }

      if (n === 2) {
        const other = (current + 1) % 2
        return [
          { key: 'current', card: this.execActiveCards[current], index: current, role: 'current' },
          { key: 'peek', card: this.execActiveCards[other], index: other, role: 'peek' }
        ]
      }

      return []
    },

    internalCurrentCard () {
      return this.internalActiveCards[this.internalIndex] || null
    },

    internalActiveCards () {
      return this.internalAuditCards || []
    },

    internalVisibleCards () {
      const n = this.internalActiveCards.length
      if (!n) return []
      const current = this.internalIndex
      const useListLayout = n >= 3

      if (useListLayout) {
        return this.internalActiveCards.map((card, index) => ({
          key: `internal-${card.id || index}`,
          card,
          index,
          role: index === current ? 'current' : 'list'
        }))
      }

      if (n === 1) {
        return [
          { key: 'current', card: this.internalActiveCards[current], index: current, role: 'current' }
        ]
      }

      if (n === 2) {
        const other = (current + 1) % 2
        return [
          { key: 'current', card: this.internalActiveCards[current], index: current, role: 'current' },
          { key: 'peek', card: this.internalActiveCards[other], index: other, role: 'peek' }
        ]
      }

      return []
    },

    commissionerCurrentCard () {
      return this.commissionerActiveCards[this.commissionerIndex] || null
    },

    commissionerActiveCards () {
      return this.commissionerCommitteeData[this.commSelected] || []
    },

    commissionerVisibleCards () {
      const n = this.commissionerActiveCards.length
      if (!n) return []
      const current = this.commissionerIndex
      const useListLayout = n >= 3

      if (useListLayout) {
        return this.commissionerActiveCards.map((card, index) => ({
          key: `committees-${card.id || index}`,
          card,
          index,
          role: index === current ? 'current' : 'list'
        }))
      }

      if (n === 1) {
        return [
          { key: 'current', card: this.commissionerActiveCards[current], index: current, role: 'current' }
        ]
      }

      if (n === 2) {
        const other = (current + 1) % 2
        return [
          { key: 'current', card: this.commissionerActiveCards[current], index: current, role: 'current' },
          { key: 'peek', card: this.commissionerActiveCards[other], index: other, role: 'peek' }
        ]
      }

      return []
    },

    directorCurrentCard () {
      return this.directorActiveCards[this.directorIndex] || null
    },

    directorActiveCards () {
      return this.directorCommitteeData[this.directorSelected] || []
    },

    directorVisibleCards () {
      const n = this.directorActiveCards.length
      if (!n) return []
      const current = this.directorIndex
      const useListLayout = n >= 3

      if (useListLayout) {
        return this.directorActiveCards.map((card, index) => ({
          key: `directors-${card.id || index}`,
          card,
          index,
          role: index === current ? 'current' : 'list'
        }))
      }

      if (n === 1) {
        return [
          { key: 'current', card: this.directorActiveCards[current], index: current, role: 'current' }
        ]
      }

      if (n === 2) {
        const other = (current + 1) % 2
        return [
          { key: 'current', card: this.directorActiveCards[current], index: current, role: 'current' },
          { key: 'peek', card: this.directorActiveCards[other], index: other, role: 'peek' }
        ]
      }

      return []
    },

    currentBoardLabel () {
      const found = this.boardOptions.find((opt) => opt.key === this.selectedBoard)
      return found ? found.label : "Komisaris"
    }
  },

  watch: {
    currentIndex () {
      this.$nextTick(() => this.scrollActiveThumb('commissionerStrip'))
    },
    selectedBoard () {
      this.$nextTick(() => this.scrollActiveThumb('commissionerStrip'))
    },
    internalIndex () {
      this.$nextTick(() => this.scrollActiveThumb('internalStrip'))
    },
    execIndex () {
      this.$nextTick(() => this.scrollActiveThumb('execStrip'))
    },
    execSelected () {
      this.$nextTick(() => this.scrollActiveThumb('execStrip'))
    },
    commissionerIndex () {
      this.$nextTick(() => this.scrollActiveThumb('committeeStrip'))
    },
    commSelected () {
      this.$nextTick(() => this.scrollActiveThumb('committeeStrip'))
    }
  },

  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
    this.$nextTick(() => {
      this.scrollActiveThumb('commissionerStrip')
      this.scrollActiveThumb('internalStrip')
      this.scrollActiveThumb('execStrip')
      this.scrollActiveThumb('committeeStrip')
    })
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    scrollActiveThumb (refName) {
      const wrap = this.$refs[refName]
      if (!wrap || !wrap.querySelector) return
      const activeEl = wrap.querySelector('.commissioner-thumb-wrapper--active')
      if (!activeEl) return

      // Posisikan center secara konsisten di view horizontal
      const wrapRect = wrap.getBoundingClientRect()
      const activeRect = activeEl.getBoundingClientRect()
      const currentScroll = wrap.scrollLeft
      const targetScroll = currentScroll + (activeRect.left - wrapRect.left) - (wrapRect.width / 2 - activeRect.width / 2)

      wrap.scrollTo({
        left: Math.max(0, targetScroll),
        behavior: 'smooth'
      })
    },

    handleKeydown (event) {
      const target = event.target
      const tag = target && target.tagName

      // Skip when typing inside form fields or editable content
      if (
        (tag && ['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)) ||
        (target && target.isContentEditable)
      ) {
        return
      }

      if (event.key === 'ArrowLeft') {
        this.handleArrowNavigation('prev')
      } else if (event.key === 'ArrowRight') {
        this.handleArrowNavigation('next')
      }
    },

    handleArrowNavigation (direction) {
      const goNext = direction === 'next'

      switch (this.activeTab) {
        case 1:
          goNext ? this.nextCard() : this.prevCard()
          break
        case 2:
          goNext ? this.nextExec() : this.prevExec()
          break
        case 3:
          goNext ? this.nextInternal() : this.prevInternal()
          break
        case 4:
          goNext ? this.nextCommissioner() : this.prevCommissioner()
          break
        case 5:
          goNext ? this.nextDirector() : this.prevDirector()
          break
        default:
          break
      }
    },

    nextCard () {
      if (!this.activeCards.length) return
      this.isReverse = false // slide dari kanan ke tengah
      this.currentIndex = (this.currentIndex + 1) % this.activeCards.length
    },

    prevCard () {
      if (!this.activeCards.length) return
      this.isReverse = true // slide dari kiri ke tengah
      this.currentIndex = (this.currentIndex - 1 + this.activeCards.length) % this.activeCards.length
    },

    goTo (index) {
      if (!this.activeCards.length) return
      // klik foto samping -> aktifkan & tentukan arah animasi
      this.isReverse = index < this.currentIndex
      this.currentIndex = index
    },

    imageSlideClass () {
      return ''
    },

    selectBoard (key) {
      this.selectedBoard = key
      this.currentIndex = 0
      this.isReverse = false
    },

    nextExec () {
      if (!this.execActiveCards.length) return
      this.execIsReverse = false
      this.execIndex = (this.execIndex + 1) % this.execActiveCards.length
    },

    prevExec () {
      if (!this.execActiveCards.length) return
      this.execIsReverse = true
      this.execIndex = (this.execIndex - 1 + this.execActiveCards.length) % this.execActiveCards.length
    },

    goToExec (index) {
      if (!this.execActiveCards.length) return
      this.execIsReverse = index < this.execIndex
      this.execIndex = index
    },

    execImageSlideClass () {
      return ''
    },

    selectExecBoard (key) {
      this.execSelected = key
      this.execIndex = 0
      this.execIsReverse = false
    },

    selectCommsBoard (key) {
      this.commSelected = key
      this.commissionerIndex = 0
      this.commissionerIsReverse = false
    },

    selectDirectorBoard (key) {
      this.directorSelected = key
      this.directorIndex = 0
      this.directorIsReverse = false
    },

    nextInternal () {
      if (!this.internalActiveCards.length) return
      this.internalIsReverse = false
      this.internalIndex = (this.internalIndex + 1) % this.internalActiveCards.length
    },

    prevInternal () {
      if (!this.internalActiveCards.length) return
      this.internalIsReverse = true
      this.internalIndex = (this.internalIndex - 1 + this.internalActiveCards.length) % this.internalActiveCards.length
    },

    goToInternal (index) {
      if (!this.internalActiveCards.length) return
      this.internalIsReverse = index < this.internalIndex
      this.internalIndex = index
    },

    nextCommissioner () {
      if (!this.commissionerActiveCards.length) return
      this.commissionerIsReverse = false
      this.commissionerIndex = (this.commissionerIndex + 1) % this.commissionerActiveCards.length
    },

    prevCommissioner () {
      if (!this.commissionerActiveCards.length) return
      this.commissionerIsReverse = true
      this.commissionerIndex = (this.commissionerIndex - 1 + this.commissionerActiveCards.length) % this.commissionerActiveCards.length
    },

    goToCommissioner (index) {
      if (!this.commissionerActiveCards.length) return
      this.commissionerIsReverse = index < this.commissionerIndex
      this.commissionerIndex = index
    },

    nextDirector () {
      if (!this.directorActiveCards.length) return
      this.directorIsReverse = false
      this.directorIndex = (this.directorIndex + 1) % this.directorActiveCards.length
    },

    prevDirector () {
      if (!this.directorActiveCards.length) return
      this.directorIsReverse = true
      this.directorIndex = (this.directorIndex - 1 + this.directorActiveCards.length) % this.directorActiveCards.length
    },

    goToDirector (index) {
      if (!this.directorActiveCards.length) return
      this.directorIsReverse = index < this.directorIndex
      this.directorIndex = index
    },

    useGrid (length, boardKey) {
      if (boardKey === 'syariah') return length >= 2
      return length >= 3
    },

    imageHeight () {
      const isMobile = this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.smAndDown
      return isMobile ? 220 : 260
    },

    imageWidth () {
      const isMobile = this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.smAndDown
      return isMobile ? 160 : 200
    }
  }
};
</script>

<style scoped>
.structure-shell {
  background: linear-gradient(135deg,#d8e7e9 0%,#e9ebde 45%,#fff4e6 100%);
  border-radius: 30px;
  padding: 32px;
  color: #0f1f2d;
  border: 1px solid #e2e8f0;
  box-shadow: 0 15px 50px rgba(14, 165, 233, 0.12);
}

.structure-tabs {
  margin-bottom: 16px;
}

.structure-tabs .v-item-group {
  flex-wrap: wrap;
}

.structure-tabs .v-tab {
  background: #ffffff;
  border-radius: 999px;
  margin: 4px 8px 4px 0;
  padding: 8px 20px;
  text-transform: none;
  letter-spacing: 0.02em;
  color: #0f172a;
  min-height: 40px;
  border: 1px solid #e2e8f0;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.structure-tabs .v-tab::before {
  opacity: 0;
}

.structure-tabs .v-tab--active {
  background: linear-gradient(120deg, #038594, #008493);
  color: #ffffff;
  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.3);
}

.structure-tabs .v-tabs-slider {
  height: 0;
}

.structure-panels {
  margin-top: 12px;
}

.structure-visual__media {
  border-radius: 20px;
  width: 100%;
  min-height: 620px;
  box-shadow: 0 20px 45px rgba(15, 118, 110, 0.2);
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.26em;
  font-size: 0.72rem;
  color: #0f766e;
  margin-bottom: 8px;
}

.management-grid,
.committee-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}

.management-card,
.committee-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px rgba(22, 163, 74, 0.08);
  color: #0f172a;
}

.management-card ul,
.committee-card ul {
  list-style: none;
  padding: 0;
  margin: 16px 0 0;
}

.management-card li,
.committee-card li {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.management-card .name,
.committee-card .name {
  font-weight: 600;
  color: #0f172a;
}

.management-card .role,
.committee-card .role {
  color: #0f766e;
  font-size: 0.92rem;
}

.executive-table {
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 15px 35px rgba(14, 165, 233, 0.12);
}

.executive-table header,
.executive-row {
  display: grid;
  grid-template-columns: 1.4fr 1.2fr 1fr 1fr;
  padding: 14px 20px;
  gap: 12px;
  color: #0f172a;
}

.executive-table header {
  background: #ecfdf5;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.executive-row:nth-child(odd) {
  background: #f8fafc;
}

.executive-row span:last-child {
  color: #0284c7;
}

.footnote {
  color: #0f766e;
  font-size: 0.85rem;
  margin-top: 12px;
}

@media (max-width: 960px) {
  .structure-shell {
    padding: 22px;
  }

  .structure-tabs .v-tab {
    margin-bottom: 8px;
  }

  .structure-visual__media {
    width: 100%;
    min-height: 0;
    height: auto !important;
    aspect-ratio: 16 / 9;
  }

  .executive-table header,
  .executive-row {
    grid-template-columns: 1fr;
  }

  .commissioner-strip,
  .commissioner-strip--grid {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    gap: 12px;
    padding-bottom: 6px;
  }

  .commissioner-thumb-wrapper {
    flex: 0 0 160px;
    margin: 0 6px;
    padding:5px
  }

  .director-card-grid,
  .management-grid,
  .committee-grid {
    grid-template-columns: none;
    grid-auto-flow: column;
    grid-auto-columns: minmax(260px, 1fr);
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 12px;
    padding-bottom: 6px;
  }

  .director-card,
  .management-card,
  .committee-card {
    min-width: 260px;
  }
}

.commissioner-strip {
  overflow: visible;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.commissioner-strip--grid {
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 16px;
}

.commissioner-strip--grid .commissioner-thumb-wrapper {
  flex: 0 0 180px;
  margin: 0;
}

.commissioner-strip--grid .commissioner-thumb {
  width: 100%;
}

.commissioner-strip--single {
  justify-content: center !important;
}

/* wrapper tiap foto */
.commissioner-thumb-wrapper {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* gambar */
.commissioner-thumb {
  border-radius: 12px;
  object-fit: cover;
  object-position: center;
  transition:
    transform 0.45s cubic-bezier(0.25, 0.8, 0.25, 1),
    filter 0.45s cubic-bezier(0.25, 0.8, 0.25, 1),
    opacity 0.45s cubic-bezier(0.25, 0.8, 0.25, 1),
    box-shadow 0.45s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* tengah: besar & highlight */
.commissioner-thumb--active {
  transform: none;
  filter: grayscale(0);
  opacity: 1;
  box-shadow:
    0 16px 36px rgba(0, 0, 0, 0.18),
    0 0 0 6px rgba(0, 212, 255, 0.16);
}

/* sisi kiri/kanan: lebih kecil + abu-abu */
.commissioner-thumb--inactive {
  filter: none;
  opacity: 0.92;
  box-shadow: 0 18px 44px rgba(10, 40, 79, 0.25);
}

.commissioner-thumb-wrapper--peek {
  margin-left: -140px;
  opacity: 0.7;
  z-index: 1;
}

.director-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 18px;
}

.director-card {
  position: relative;
  background: linear-gradient(135deg,#d8e7e9 0%,#e9ebde 45%,#fff4e6 100%);
  border-radius: 18px;
  padding: 18px;
  color: black;
  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.director-card__accent {
  position: absolute;
  top: -40px;
  right: -60px;
  width: 140px;
  height: 140px;
  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.22), transparent 60%);
  opacity: 0.85;
}

.director-card__name {
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.02em;
}

.director-card__title {
  margin-top: 6px;
  font-size: 0.98rem;
  color: black;
}

.director-card__detail {
  color: black;
  font-size: 0.92rem;
  line-height: 1.5;
}

.director-section {
  background: #ffffff;
  border-radius: 18px;
}

.audit-section {
  background: #ffffff !important;
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
}


.board-chip-group {
  background: #ffffff;
  border-radius: 999px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 6px 18px rgba(15, 118, 110, 0.12);
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  align-items: center;
  width: max-content;
}

.board-chip-slide {
  width: auto;
  display: flex;
  align-items: center;
}

.chip-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 transparent;
}

.board-chip-slide .v-slide-group__wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  align-items: center;
}

.board-chip-slide .v-slide-group__content {
  flex-wrap: nowrap;
  align-items: center;
}

.board-chip-slide .v-slide-item {
  flex: 0 0 auto;
}

.option-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: nowrap;
}

.option-bar__chips {
  flex: 1 1 auto;
  min-width: 0;
}

.option-bar__arrows {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.board-chip {
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  color: #0f172a;
  transition: all 0.2s ease;
  user-select: none;
  outline: none;
}

.board-chip:focus-visible {
  box-shadow: 0 0 0 2px rgba(3, 133, 148, 0.2);
}

.board-chip--active {
  background: linear-gradient(120deg, #038594, #008493);
  color: #ffffff;
  box-shadow: 0 6px 18px rgba(3, 133, 148, 0.35);
}
/* --- ANIMASI SLIDE HANYA UNTUK FOTO TENGAH --- */

/* slide keyframes removed to minimize flicker */

@media (max-width: 960px) {
  .board-chip-group {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #94a3b8 transparent;
    padding-bottom: 6px;
    gap: 8px;
    min-width: 0;
    flex: 1 1 auto;
  }

  .board-chip {
    flex: 0 0 auto;
  }

  /* Pastikan chip v-slide-item tetap sebaris dan bisa discroll ke kanan */
  ::v-deep .board-chip-slide .v-slide-group__wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  ::v-deep .board-chip-slide .v-slide-group__content {
    flex-wrap: nowrap !important;
    justify-content: flex-start;
    gap: 8px;
    white-space: nowrap;
  }

  ::v-deep .board-chip-slide .v-slide-item {
    flex: 0 0 auto;
  }
}

/* Re-apply mobile rules after base styles to keep thumbnails horizontal */
@media (max-width: 960px) {
  .commissioner-strip,
  .commissioner-strip--grid {
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start !important;
    gap: 12px;
    padding: 0 calc(50% - 90px) 6px calc(50% - 90px);
    scroll-snap-type: x mandatory;
    /* Tambah padding supaya item aktif bisa berhenti di tengah */
    scroll-padding-left: calc(50% - 90px);
    scroll-padding-right: calc(50% - 90px);
  }

  .commissioner-thumb-wrapper {
    flex: 0 0 180px;
    margin: 12px 6px;
    scroll-snap-align: center;
  }

  .commissioner-thumb {
    object-fit: contain;
    object-position: center top;
    padding: 8px 0;
  }

  .commissioner-strip--single {
    justify-content: center !important;
    overflow: visible !important;
    gap: 0;
  }
}
</style>

